module.exports = __webpack_public_path__ + "static/img/application12-2.9193af0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application12-2.jpg
// module id = PFOL
// module chunks = 0